import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import seoConfig from "./seoConfig";
import { trackPageView } from "./ga";

const AutoSEO = () => {
  const location = useLocation();

  /* -------- GOOGLE ANALYTICS PAGE VIEW -------- */
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  /* -------- SEO LOGIC -------- */
  const segments = location.pathname.split("/").filter(Boolean);
  let key = segments[0] || "home";

  if (key === "service-single") key = "serviceSingle";
  if (key === "project-single") key = "projectSingle";
  if (key === "blog-single") key = "blogSingle";

  if (key === "about") key = "about";
  if (key === "services") key = "services";
  if (key === "projects") key = "projects";
  if (key === "blog") key = "blog";
  if (key === "contact") key = "contact";

  const seo = seoConfig[key] || seoConfig.home;

 return (
  <Helmet prioritizeSeoTags>
    <title>{seo.title}</title>

    <meta name="description" content={seo.description} />

    {seo.keywords && (
      <meta name="keywords" content={seo.keywords} />
    )}

    {/* ✅ CANONICAL URL (VERY IMPORTANT FOR SEO) */}
    <link
      rel="canonical"
      href={`https://yvreddyassociates.com${location.pathname}`}
    />
  </Helmet>
);

};

export default AutoSEO;
